<template>
  <div class="container">
    <div class="row">
      <!--<div class="offset-md-1 col-md-10 px-md-5">-->
      <div class="col-12 offset-lg-2 col-lg-8">
        <page-content ref="pageContent" :organizations="organizations" :viewingEvents="viewingEvents" :isEmptyCartPhotos="isEmptyCartPhotos" pageType="Viewing"></page-content>

        <!-- フォーム送信UI -->
        <div class="row text-center">
          <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
            <div class="my-4">
              <h3 class="h6 font-size-1 mb-1">
                <trans-text i18nKey="ui['5_1'][13]"/>
              </h3>
              <button type="button" class="btn-add-school-code btn w-100 btn-lg btn-danger" ref="toggleShoolCodePopoverFormBtn" @click="toggleShoolCodePopoverForm"><trans-text i18nKey="ui['5_1'][14]"/></button>
            </div>
          </div>
        </div>
      </div>
      <add-school-code-popover v-show="isShowShoolCodePopoverForm" ref="shoolCodePopoverForm" @fetchOrganization="fetchOrganization"></add-school-code-popover>
    </div>

  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import PageContent from 'page/partials/MyPage/EventInfo/PageContent.vue'
  import AddSchoolCodePopover from 'components/popover/AddSchoolCodePopover.vue'
  import Organization from 'processor/Organization'

  /** @name page_subPages_MyPage_Event_Viewing */
  export default {
    name:"",
    components: {
      PageContent,
      AddSchoolCodePopover
    },
    props:["organizations","viewingEvents","isEmptyCartPhotos"],
    data () {
      return {
        isShowShoolCodePopoverForm:false,
        isShowEventKeyPopoverForm:false,
      }
    },
    created(){
    },
    mounted(){
    },
    beforeRouteLeave (to, from, next) {
      this.isShowShoolCodePopoverForm=false
      this.isShowEventKeyPopoverForm=false

      this.$nextTick(function () {
        next()
      })
    },
    methods:{
      fetchOrganization(){
        this.isShowShoolCodePopoverForm=false
        this.isShowEventKeyPopoverForm=false

        this.$emit('fetchOrganization')
      },
      toggleShoolCodePopoverForm(){
        this.isShowShoolCodePopoverForm = !this.isShowShoolCodePopoverForm
        this.$nextTick(function () {
          new Tether({
            element: this.$refs.shoolCodePopoverForm.$refs.popover,
            target: this.$refs.toggleShoolCodePopoverFormBtn,
            attachment: 'top center',
            targetAttachment: 'bottom center',
          });
        })
      },
    }
  }
</script>


<style lang="scss" scoped>
  .btn-add-school-code{
    position: relative;
    &:before{
      font-family: FontAwesome;
      content: '\f271';
      font-size:1.2rem;
      color: #fff;
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(0);
      left: 5%;
    }
  }
</style>



// WEBPACK FOOTER //
// Viewing.vue?8a58501a